{
  "dashboard.activity.empty": "There is no activity in this time range.",
  "dashboard.activity.error": "Could not load recent activity. Try again.",
  "dashboard.activity.failed": "Failed",
  "dashboard.activity.failed_jobs": "Failed jobs",
  "dashboard.activity.operations": "Recent operations",
  "dashboard.activity.security_events": "Security events",
  "dashboard.activity.succeeded": "Succeeded",
  "dashboard.activity.title": "Recent activity",
  "dashboard.activity.unknown_error": "Unknown error code",
  "dashboard.intro": "Review your workspace and available administration tools in one place.",
  "dashboard.metrics.jobs.failed": "Failed jobs",
  "dashboard.metrics.messages.published": "Published notices",
  "dashboard.metrics.security.open": "Open security events",
  "dashboard.metrics.sessions.active": "Active sessions",
  "dashboard.metrics.users.new": "New users",
  "dashboard.metrics.users.total": "Total users",
  "dashboard.quick_access": "Quick access",
  "dashboard.range.30d": "30 days",
  "dashboard.range.7d": "7 days",
  "dashboard.range.90d": "90 days",
  "dashboard.range.label": "Time range",
  "dashboard.severity.critical": "Critical",
  "dashboard.severity.high": "High",
  "dashboard.severity.info": "Info",
  "dashboard.severity.low": "Low",
  "dashboard.severity.medium": "Medium",
  "dashboard.summary.empty": "There are no metrics this account can view.",
  "dashboard.summary.error": "Could not load Dashboard metrics. Try again.",
  "dashboard.summary.title": "Key metrics",
  "dashboard.trends.chart_label": "Daily Dashboard trend line chart",
  "dashboard.trends.day": "Day",
  "dashboard.trends.empty": "There are no trend series this account can view.",
  "dashboard.trends.error": "Could not load trend data. Try again.",
  "dashboard.trends.series.jobs.failed": "Failed jobs",
  "dashboard.trends.series.logins.failure": "Failed sign-ins",
  "dashboard.trends.series.logins.success": "Successful sign-ins",
  "dashboard.trends.series.security.events": "Security events",
  "dashboard.trends.series.users.new": "New users",
  "dashboard.trends.table_toggle": "View trend data table",
  "dashboard.trends.title": "Trends",
  "menu.dashboard": "Dashboard",
  "menu.system": "System",
  "menu.system.access": "Access Control",
  "menu.system.access.menus": "Menus",
  "menu.system.access.permissions": "Permission Catalog",
  "menu.system.access.roles": "Roles",
  "menu.system.content": "Content management",
  "menu.system.content.articles": "Articles",
  "menu.system.content.categories": "Article categories",
  "menu.system.integrations": "Jobs & Integrations",
  "menu.system.integrations.api-clients": "API Clients",
  "menu.system.integrations.schedules": "Scheduled Jobs",
  "menu.system.integrations.webhooks": "Webhooks",
  "menu.system.mobile": "Mobile management",
  "menu.system.mobile.releases": "Release policies",
  "menu.system.monitoring": "Monitoring",
  "menu.system.monitoring.health": "Service Status",
  "menu.system.monitoring.sessions": "Online Sessions",
  "menu.system.notifications": "Notification Center",
  "menu.system.notifications.deliveries": "Delivery Records",
  "menu.system.notifications.push_channels": "Push Channels",
  "menu.system.notifications.messages": "In-app Messages",
  "menu.system.notifications.notices": "Announcements",
  "menu.system.notifications.templates": "Notification Templates",
  "menu.system.security": "Audit & Security",
  "menu.system.security.block-rules": "Access Rules",
  "menu.system.security.events": "Security Events",
  "menu.system.security.login-logs": "Login Logs",
  "menu.system.security.operation-logs": "Operation Logs",
  "menu.system.settings": "System Settings",
  "menu.system.settings.configs": "System Configuration",
  "menu.system.settings.dictionaries": "Dictionaries",
  "menu.system.settings.modules": "Modules",
  "menu.system.settings.regions": "Regions",
  "menu.system.storage": "File Storage",
  "menu.system.storage.files": "Files",
  "menu.system.users": "User Management",
  "menu.system.users.accounts": "Users",
  "menu.system.users.departments": "Departments",
  "menu.system.users.positions": "Positions",
  "menu.system.users.tenants": "Tenants",
  "routes.auth.forgot-password.title": "Forgot Password",
  "routes.auth.login.title": "Sign In",
  "routes.auth.oauth-callback.title": "Third-party Sign-in",
  "routes.auth.register.title": "Create Account",
  "routes.auth.reset-password.title": "Reset Password",
  "routes.dashboard.title": "Dashboard",
  "routes.errors.forbidden.title": "Access Denied",
  "routes.errors.not-found.title": "Page Not Found",
  "routes.errors.offline.dashboard": "Return to Dashboard",
  "routes.errors.offline.description": "The Admin cannot reach the network. Check your connection, then retry this page. Pending write operations are not replayed automatically.",
  "routes.errors.offline.retry": "Retry connection",
  "routes.errors.offline.title": "Offline",
  "routes.errors.server-error.title": "Service Error",
  "routes.profile.basic.title": "Basic Settings",
  "routes.profile.connections.title": "Connected Accounts",
  "routes.profile.security.title": "Security Settings",
  "routes.system.access.menus.title": "Menus",
  "routes.system.access.permissions.title": "Permission Catalog",
  "routes.system.access.role-detail.title": "Role Details",
  "routes.system.access.roles.title": "Roles",
  "routes.system.content.articles.title": "Article management",
  "routes.system.content.categories.title": "Article categories",
  "routes.system.integrations.api-client-detail.title": "API Client Details",
  "routes.system.integrations.api-clients.title": "API Clients",
  "routes.system.integrations.schedule-runs.title": "Execution History",
  "routes.system.integrations.schedules.title": "Scheduled Jobs",
  "routes.system.integrations.webhook-deliveries.title": "Webhook Deliveries",
  "routes.system.integrations.webhooks.title": "Webhooks",
  "routes.system.mobile.releases.title": "Mobile release policies",
  "routes.system.monitoring.health.title": "Service Status",
  "routes.system.monitoring.sessions.title": "Online Sessions",
  "routes.system.notifications.deliveries.title": "Delivery Records",
  "routes.system.notifications.push_channels.title": "Push Channels",
  "routes.system.notifications.message-detail.title": "Message Details",
  "routes.system.notifications.messages.title": "In-app Messages",
  "routes.system.notifications.notice-detail.title": "Announcement Details",
  "routes.system.notifications.notices.title": "Announcements",
  "routes.system.notifications.templates.title": "Notification Templates",
  "routes.system.security.block-rules.title": "Access Rules",
  "routes.system.security.event-detail.title": "Security Event Details",
  "routes.system.security.events.title": "Security Events",
  "routes.system.security.login-logs.title": "Login Logs",
  "routes.system.security.operation-logs.title": "Operation Logs",
  "routes.system.settings.configs.title": "System Configuration",
  "routes.system.settings.dictionaries.title": "Dictionaries",
  "routes.system.settings.modules.title": "Modules",
  "routes.system.settings.regions.title": "Regions",
  "routes.system.storage.file-detail.title": "File Details",
  "routes.system.storage.files.title": "Files",
  "routes.system.users.account-detail.title": "User Details",
  "routes.system.users.accounts.title": "Users",
  "routes.system.users.departments.title": "Departments",
  "routes.system.users.positions.title": "Positions",
  "routes.system.users.tenant-detail.title": "Tenant Details",
  "routes.system.users.tenants.title": "Tenants",
  "shell.account_information": "Current user information and account menu",
  "shell.account_no_roles": "No roles assigned",
  "shell.account_roles": "Roles",
  "shell.collapse_navigation": "Collapse navigation",
  "shell.current_tenant": "Current workspace",
  "shell.enter_fullscreen": "Enter fullscreen",
  "shell.exit_fullscreen": "Exit fullscreen",
  "shell.expand_navigation": "Expand navigation",
  "shell.fullscreen_error": "Could not change fullscreen mode",
  "shell.hide_navigation": "Hide navigation completely",
  "shell.navigation": "Main navigation",
  "shell.open_account_menu": "Open account menu",
  "shell.open_navigation": "Open navigation",
  "shell.personal_center": "Personal center",
  "shell.skip_to_content": "Skip to main content",
  "shell.switch_tenant": "Switch workspace",
  "shell.tenant_switch_error": "Could not switch workspace. Try again.",
  "shell.tenant_switch_success": "Workspace switched",
  "menu.app": "App management",
  "menu.app.applications": "Applications",
  "menu.app.upgrade_center": "App upgrade center",
  "menu.app.users": "Users",
  "menu.app.content": "Content",
  "menu.app.content.articles": "Articles",
  "menu.app.content.pages": "Single pages",
  "routes.app.applications.title": "Application management",
  "routes.app.upgrade_center.title": "App upgrade center",
  "routes.app.users.title": "App user management",
  "routes.app.content.articles.title": "App article management",
  "routes.app.content.pages.title": "App single pages",
  "menu.system.settings.share_configs": "Share configurations",
  "routes.system.settings.share_configs.title": "Share configurations",
  "menu.system.notifications.operations": "Message Operations",
  "routes.system.notifications.operations.title": "Message Operations",
  "menu.app.feedbacks": "Feedback",
  "routes.app.feedbacks.title": "Feedback",
  "menu.system.settings.login_providers": "Third-party sign-in",
  "routes.system.settings.login_providers.title": "Third-party Sign-in",
  "menu.system.ai": "AI center",
  "menu.system.ai.providers": "Providers",
  "routes.system.ai.providers.title": "Providers",
  "menu.system.ai.models": "Models and routes",
  "routes.system.ai.models.title": "Models and routes",
  "menu.system.ai.access": "Applications and access",
  "routes.system.ai.access.title": "Applications and access",
  "menu.system.ai.playground": "Playground",
  "routes.system.ai.playground.title": "Playground",
  "menu.system.ai.usage": "Usage and calls",
  "routes.system.ai.usage.title": "Usage and calls",
  "menu.app.support": "AI Customer Support",
  "menu.app.support.inbox": "Inbox",
  "routes.app.support.inbox.title": "Inbox",
  "menu.app.support.sites": "Websites",
  "routes.app.support.sites.title": "Websites",
  "menu.app.support.characters": "Characters",
  "routes.app.support.characters.title": "Characters",
  "menu.app.support.products": "Products",
  "routes.app.support.products.title": "Products",
  "menu.app.support.faq": "Knowledge and FAQ",
  "routes.app.support.faq.title": "Knowledge and FAQ",
  "menu.app.support.settings": "Settings",
  "routes.app.support.settings.title": "Settings",
  "dashboard.scope_hint": "Current tenant · Dates use UTC. Delivery status is grouped by creation date; sent does not confirm receipt.",
  "dashboard.metrics.applications.active": "Enabled apps (current)",
  "dashboard.metrics.members.total": "Members (unique across apps)",
  "dashboard.metrics.members.new": "New members in period",
  "dashboard.trends.series.members.new": "New members",
  "dashboard.metrics.articles.published": "Published articles (current)",
  "dashboard.trends.series.articles.published": "Articles published",
  "dashboard.metrics.articles.draft": "Article drafts (current)",
  "dashboard.metrics.deliveries.sent": "Sent notifications (created in period)",
  "dashboard.trends.series.deliveries.sent": "Sent",
  "dashboard.metrics.deliveries.failed": "Failed notifications (created in period)",
  "dashboard.trends.series.deliveries.failed": "Failed",
  "dashboard.metrics.deliveries.pending": "Pending notifications (created in period)",
  "dashboard.trends.series.deliveries.pending": "Pending",
  "dashboard.groups.business": "Apps and members",
  "dashboard.groups.content": "Article publishing",
  "dashboard.groups.delivery": "Notification delivery",
  "dashboard.groups.system": "System overview",
  "dashboard.groups.growth": "User and member growth",
  "dashboard.groups.logins": "Login trends",
  "dashboard.groups.risk": "Jobs and security",
  "menu.app.commerce": "Official store",
  "routes.app.commerce.title": "Official store"
}
